import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { findIndex } from 'lodash';

import { TvScreen } from 'entities/TvRender/interfaces';
import SmallSpinner from 'modules/shared/SmallSpinner';
import { tvPanelSel } from './selectors';
import { changeScreen, getTvDataRequest, resetScreen } from './actions';
import ReadyScreen from '../ReadyScreen';
import HeaderTV from '../../components/HeaderTV';
import '../../custom.scss';

const LOGO_TIMEOUT = 60 * 1000;

export const Tvpanel: React.FC = () => {
  const dispatch = useDispatch();

  const { loading, data, screens, currentScreen, pauseData } = useSelector(tvPanelSel);

  const { frequency, logoUrl } = data;

  const isQueueEmpty = !screens || screens.length === 0;

  const onChangeScreen = () => {
    if (currentScreen && screens) {
      if (currentScreen.type === 'location' && currentScreen.locationId === 0) {
        return dispatch(changeScreen(null));
      }

      const idx = findIndex(
        screens,
        (d: TvScreen) =>
          (d.type === 'location' && currentScreen.type === 'location' && d.locationId === currentScreen.locationId) ||
          (d.type === 'custom' && currentScreen.type === 'custom' && d.imageUrl === currentScreen.imageUrl),
      );

      if (!pauseData?.licensePlates?.length && idx + 2 > screens.length) {
        return dispatch(changeScreen(null));
      }
      if (idx + 2 > screens.length) {
        return dispatch(changeScreen(pauseData));
      }

      const newScreen = screens[idx + 1];

      dispatch(changeScreen(newScreen));
    }
  };

  useEffect(() => {
    if (!currentScreen) {
      dispatch(getTvDataRequest());
    }

    const timerID = setTimeout(() => onChangeScreen(), frequency * 1000);
    return () => clearTimeout(timerID);
  }, [currentScreen, frequency]);

  useEffect(() => {
    if (!loading && isQueueEmpty && !currentScreen && logoUrl) {
      const logoTimer = setTimeout(() => dispatch(getTvDataRequest()), LOGO_TIMEOUT);
      return () => clearTimeout(logoTimer);
    }
  });

  useEffect(
    () => () => {
      dispatch(resetScreen());
    },
    [],
  );

  return (
    <div className="tv-main">
      <HeaderTV />

      {loading && <SmallSpinner />}
      {!loading && currentScreen && <ReadyScreen presentScreen={currentScreen} />}
      {!loading && isQueueEmpty && !currentScreen && logoUrl && (
        <div className="h-100 d-flex flex-row align-items-center justify-content-center">
          <div className="h-75">
            <img className="company-logo" src={logoUrl} alt="Логотип компанії" />
          </div>
        </div>
      )}
    </div>
  );
};
